"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebPageOpen = void 0;
const blizzard_1 = require("@snapchat/blizzard");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const web_log_1 = require("@snapchat/web-log");
const react_1 = require("react");
function useWebPageOpen() {
    (0, react_1.useEffect)(() => {
        const pageOpenListener = () => {
            (0, blizzard_1.onPageOpen)();
            if (graphene_1.default.isReady()) {
                graphene_1.default.increment({
                    metricsName: "BlizzardEvents.WebPageOpen.Reported",
                    value: 1,
                });
            }
            else {
                web_log_1.log.error("BlizzardEvents.WebPageOpen.Reported failed because Graphene was not ready.");
            }
        };
        pageOpenListener();
        addEventListener("focus", pageOpenListener);
        addEventListener("blur", blizzard_1.onPageClose);
        return () => {
            removeEventListener("focus", pageOpenListener);
            removeEventListener("blur", blizzard_1.onPageClose);
        };
    }, []);
}
exports.useWebPageOpen = useWebPageOpen;
//# sourceMappingURL=WebPageOpen.js.map